import { Button, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import ProductLinkButton from "./ProductLinkButton";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Employer({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const data = record?.data?.basic?.employer;
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        sEmployerHrInstruction: data?.sEmployerHrInstruction || "",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = "employer";
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id="section_employer">
      <SectionTitle title="Employer - Set requirements for employer partners of this products" />
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} container spacing={1}>
            <Typography>
              <ProductLinkButton title="Employer" href="/employers" />
              &nbsp;&nbsp;( Please check it on Employer List )
            </Typography>
            <Grid item xs={12}>
              <Controller
                name="sEmployerHrInstruction"
                control={control}
                render={({ field }) => (
                  <CustomProductTextField
                    {...field}
                    label="Instruction to Employer HR"
                    fullWidth
                    rows={4}
                    multiline={true}
                    variant="outlined"
                    placeholder="Text (512 Char Limit)"
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* Form Actions */}
          <CustomProductActionBottom>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveClick}
              disabled={!isDirty}
              sx={{ width: "120px", mt: 1 }}
            >
              Save
            </Button>
          </CustomProductActionBottom>
        </Grid>
      </Box>
    </SectionStyled>
  );
}
